import Link from 'next/link';
import { IS_PREBOOK_FLOW } from '@/constants/common';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { Brand } from '@/models/Product';
import styles from '@/styles/TruncateContent.module.css';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import { setLocalStorageKey } from '@/utils/helper';

// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import LazyImage from '../LazyImage';
import Paragraph, { VARIANT } from '../Paragraph';
interface Props {
  brand: Brand;
  className?: string;
  isPrebook?: boolean;
}
const BrandImageName = ({
  brand: {
    name,
    imageUrl,
    slug
  },
  className = '',
  isPrebook = false
}: Props) => {
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const slugEnc = encodeURIComponent(slug?.slug || '');
  const onBrandClick = () => {
    trackCustomEvent(CustomEventTypes.OPEN_PRODUCT_LIST, name);
    if (isPrebook) {
      // Product listing fetches only read the flow from storage
      setLocalStorageKey(IS_PREBOOK_FLOW, true);
    }
  };
  return <Link href={`/products/brands/${slugEnc}${isPrebook ? '?prebook=true' : ''}`} className={`flex flex-col relative w-20 ${className}`} onClick={onBrandClick} data-sentry-element="Link" data-sentry-component="BrandImageName" data-sentry-source-file="BrandImageName.tsx">
      <div className="mb-2 w-20 h-20">
        <LazyImage alt={name} fallBackIcon={<div className="flex justify-center items-center bg-neutral-300 rounded-full w-20 h-20 overflow-hidden">
              <span className="text-4xl">{name[0]}</span>
            </div>} imageUrl={imageUrl} className="rounded-full w-20 h-20 object-cover" data-sentry-element="LazyImage" data-sentry-source-file="BrandImageName.tsx" />
      </div>
      <Paragraph className={`text-center ${styles.truncate_after_two_lines}`} variant={VARIANT.MEDIUM} data-sentry-element="Paragraph" data-sentry-source-file="BrandImageName.tsx">
        {name}
      </Paragraph>
    </Link>;
};
export default BrandImageName;